import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import { BrandProvider } from "./branding/BrandContext";
import "./assets/stylesheets/App.css";
import "./assets/stylesheets/survey.css";

const { getBrandByKey, resolveBrandFromHostname } = require("../../shared/branding");

const initialHostname =
  typeof window !== "undefined" ? window.location.hostname : "";
const configuredBrandKey = import.meta.env.VITE_BRAND_KEY || "";
const initialBrand = configuredBrandKey
  ? getBrandByKey(configuredBrandKey)
  : resolveBrandFromHostname(initialHostname);

if (typeof window !== "undefined") {
  window.__HOMEHELPER_BRAND__ = {
    brandKey: initialBrand.brandKey,
    brandName: initialBrand.brandName,
    hostname: initialHostname,
  };
}

if (typeof document !== "undefined") {
  document.documentElement.dataset.brand = initialBrand.brandKey;
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrandProvider brand={initialBrand} hostname={initialHostname}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </BrandProvider>
  </React.StrictMode>
);
